import { apiGet, apiGetAdmin, apiPostAdmin, apiPostCustomer } from './apiClient';

export const fetchTsrFoodCategories = async () => apiGet('/tsrfood/getCategories');

export const fetchTsrFoodQuantityRoundRules = async () => apiGet('/tsrfood/quantityRoundRules');

export const fetchTsrFoodItems = async () => apiGet('/tsrfood/getItems');

export const fetchTsrFoodItemsAdmin = async () => apiGetAdmin('/tsrfood/items/admin');

export const fetchTsrFoodItemById = async (foodItemId) => {
  const params = new URLSearchParams({ FoodItemId: String(foodItemId) });
  return apiGetAdmin(`/tsrfood/items/byId?${params.toString()}`);
};

export const saveTsrFoodItem = async (payload) => apiPostAdmin('/tsrfood/items/save', payload);

export const saveTsrFoodPackage = async (payload) => apiPostAdmin('/tsrfood/savePackage', payload);

export const submitTsrFoodOrder = async (payload) => apiPostCustomer('/tsrfood/placeOrder', payload);

export const fetchTsrFoodCoupons = async () => apiGetAdmin('/tsrfood/coupons');

export const saveTsrFoodCoupon = async (payload) => apiPostAdmin('/tsrfood/coupons/save', payload);

export const validateTsrFoodCoupon = async (payload) => apiPostCustomer('/tsrfood/coupons/validate', payload);

export const confirmTsrFoodOrderPayment = async (payload) => (
  apiPostCustomer('/tsrfood/orders/confirm-payment', payload)
);

export const fetchTsrFoodPackages = async () => apiGet('/tsrfood/getPackages');

export const fetchTsrFoodPackageById = async (foodPackageId) => {
  const params = new URLSearchParams({ FoodPackageId: String(foodPackageId) });
  return apiGet(`/tsrfood/getPackageById?${params.toString()}`);
};

export const fetchTsrFoodPackageByIdAdmin = async (foodPackageId) => {
  const params = new URLSearchParams({ FoodPackageId: String(foodPackageId) });
  return apiGetAdmin(`/tsrfood/getPackageById?${params.toString()}`);
};
